export default "__VITE_ASSET__CSau3G6X__"